const templates = [
  {
    title: "New Table",
    description: "creates a new table",
    content:
      '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>'
  },
  {
    title: "Starting my story",
    description: "A cure for writers block",
    content: "Once upon a time..."
  },
  {
    title: "New list with dates",
    description: "New List with dates",
    content:
      '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>'
  }
];

export default templates;
